// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"70":"1e340630","260":"7ab59983","290":"ae4bc467","345":"b071e144","554":"1871279f","636":"24b38779","789":"bb2c30aa"}[chunkId] + ".js";
};